import React, { useState } from 'react';

import { userRoles } from 'constants/users';
import { FilterContainer, ClearAllContainer, Title, Hr, CheckboxContainer } from './filterStyles';
import { Checkbox } from 'components/Checkbox/Checkbox';

export default function Filter({ filterOptions, filterValues, userRole, clearFilters, defaultFilterOptions }) {
  const [filter, setFilter] = useState(filterOptions);

  const setValue = (change) => {
    let filterCopy = { ...filter, ...change };
    if (userRole === userRoles.CANDIDATE && filterCopy.challenge && filterCopy.exercise && filterCopy.freecode) {
      filterCopy.selectAll = true;
    } else if (
      !filterCopy.adaptiveTest ||
      !filterCopy.generalSkills ||
      !filterCopy.multichoice ||
      !filterCopy.code ||
      !filterCopy.challenge ||
      !filterCopy.exercise ||
      !filterCopy.freecode
    ) {
      filterCopy.selectAll = false;
    } else {
      filterCopy.selectAll = true;
    }
    setFilter(filterCopy);
    return filterValues(filterCopy);
  };

  const setSelectAndDeselectAll = (value) => {
    let values = {
      ...filter,
      selectAll: value,
      adaptiveTest: value,
      generalSkills: value,
      multichoice: value,
      code: value,
      challenge: value,
      exercise: value,
      freecode: value,
    };
    setFilter(values);
    return filterValues(values);
  };

  return (
    <FilterContainer id="customTestsFilter">
      <Title>Tests</Title>
      <Hr />
      <ClearAllContainer
        onClick={() => {
          setFilter(defaultFilterOptions);
          clearFilters();
        }}
      >
        Clear All Filters
      </ClearAllContainer>
      <CheckboxContainer>
        <Checkbox
          checked={filter.selectAll}
          onChange={() => setSelectAndDeselectAll(!filter.selectAll, 'selectAll')}
          label={filter.selectAll ? 'Deselect All' : 'Select All'}
        />
        {userRole !== userRoles.CANDIDATE && (
          <Checkbox
            checked={filter.adaptiveTest}
            onChange={() => setValue({ adaptiveTest: !filter.adaptiveTest })}
            label="Adaptive Test"
          />
        )}
        {userRole !== userRoles.CANDIDATE && (
          <Checkbox
            checked={filter.generalSkills}
            onChange={() => setValue({ generalSkills: !filter.generalSkills })}
            label="General Skills"
          />
        )}
        {userRole !== userRoles.CANDIDATE && (
          <Checkbox
            checked={filter.multichoice}
            onChange={() => setValue({ multichoice: !filter.multichoice })}
            label="Multichoice"
          />
        )}
        {userRole !== userRoles.CANDIDATE && (
          <Checkbox checked={filter.code} onChange={() => setValue({ code: !filter.code })} label="Code Test" />
        )}
        <Checkbox
          checked={filter.challenge}
          onChange={() => setValue({ challenge: !filter.challenge })}
          label="Challenge"
        />
        <Checkbox
          checked={filter.exercise}
          onChange={() => setValue({ exercise: !filter.exercise })}
          label="Exercise"
        />
        <Checkbox
          checked={filter.freecode}
          onChange={() => setValue({ freecode: !filter.freecode })}
          label="Freecode"
        />
        <Hr />
        {(userRole === userRoles.SUPER_ADMIN || userRole === userRoles.CANDIDATE) && (
          <Checkbox
            checked={filter.publicFreecode}
            onChange={() => setValue({ publicFreecode: !filter.publicFreecode })}
            label="Public Freecode"
          />
        )}
      </CheckboxContainer>
      <Title>Options</Title>
      <Hr />
      <CheckboxContainer>
        <Checkbox
          checked={filter.published}
          onChange={() => setValue({ published: !filter.published })}
          label="Published"
        />
        <Checkbox checked={filter.custom} onChange={() => setValue({ custom: !filter.custom })} label="Custom" />
        <Checkbox
          checked={filter.archived}
          onChange={() => setValue({ archived: !filter.archived })}
          label="Archived"
        />
      </CheckboxContainer>
    </FilterContainer>
  );
}
